import type { SecteurZonage } from './types'

/*
  Le zonage fait autorité côté serveur : l'association doit pouvoir ajouter,
  renommer ou retirer un secteur sans qu'on redéploie l'application.

  La liste ci-dessous n'est qu'un REPLI DE SECOURS, utilisé uniquement si le
  magasin local est vide (première ouverture sans avoir jamais joint le serveur).

  Pourquoi un repli plutôt qu'un écran d'erreur : une application qui refuse
  d'enregistrer une ponte parce qu'elle n'a pas pu joindre le serveur serait un
  échec plus grave que le problème qu'on cherche à résoudre. La patrouille a
  lieu maintenant, la tortue ne repassera pas.
*/
export const ZONAGE_REPLI: SecteurZonage[] = [
  { code: 'salines_ouest', libelle: 'Salines ouest', groupe: 'Salines', ordre: 10 },
  { code: 'salines_centre', libelle: 'Salines centre', groupe: 'Salines', ordre: 20 },
  { code: 'salines_est', libelle: 'Salines est', groupe: 'Salines', ordre: 30 },
  { code: 'gosselin', libelle: 'Gosselin', groupe: null, ordre: 40 },
  { code: 'apcat', libelle: 'APCAT', groupe: null, ordre: 50 },
  { code: 'montabo', libelle: 'Montabo', groupe: null, ordre: 60 },
  { code: 'zephyr', libelle: 'Zéphyr', groupe: null, ordre: 70 },
  { code: 'montjoly_est', libelle: 'Montjoly est', groupe: null, ordre: 80 },
]

export function trierSecteurs(secteurs: SecteurZonage[]): SecteurZonage[] {
  return [...secteurs].sort((a, b) => a.ordre - b.ordre || a.libelle.localeCompare(b.libelle, 'fr'))
}

/**
 * Libellé lisible d'un code de secteur. Retombe sur le code brut si le secteur
 * a été retiré du zonage depuis la saisie — une vieille patrouille reste
 * affichable, on ne perd jamais une donnée déjà enregistrée.
 */
export function libelleSecteur(code: string, zonage: SecteurZonage[]): string {
  return zonage.find((s) => s.code === code)?.libelle ?? code
}
